export enum SelectTheme {
  blackTransparent = 'blackTransparent',
  classic = 'classic',
  classicRounded = 'classicRounded',
  darkTransparent = 'darkTransparent',
  transparent = 'transparent'
}
